// Generated by ts-to-zod
import { z } from 'zod';

export const getAsyncTaskQuerySchema = z.object({
  noRedirect: z.boolean(),
});
